<template>
  <div class="message-page">
    <div class="ceiling">
      <!-- <home-top></home-top> -->
      <!-- <top-search></top-search> -->
      <div class="search-box-box">
        <div class="back w-1400">
          <div class="search-box">
            <div class="search-box-input">
              <input type="text" placeholder="聊天搜索" v-model="keyWords" @input="lisOn"/>
              <button class="search-btn" @click="onSearch">搜索</button>
            </div>
          </div>
          <div class="message-big-img" @click="goHome">
            <img src="../../static/index/mini.png" alt="缩小"/>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="top-h"></div>-->
    <div class="message-box">
      <!-- :style="{
        backgroundImage:
          'url(' +  + ')',
      }" -->
      <div class="content" ref="messageListRef" @scroll="handleMessageListScroll">
        <!-- 聊天消息列表 -->
        <div class="message-text-list">
          <!-- 加载提示 -->
          <div v-if="showLoadingTip" class="loading-tip">
            <i class="el-icon-loading"></i>
            <span>正在加载历史消息...</span>
          </div>
          <div class="message-text-list-item-box" v-for="(item, index) in messageList" :key="index">
            <div class="message-text-list-item" v-if="item.people_id != userInfo.id">
              <div class="message-text-list-item-name">
                <img :src="item.avatar" alt="用户头像" class="message-avatar"/>
                <div class="user-info">
                    <span class="user-info-name" v-if="item.company || item.people">
                      {{ item.company || $utils.maskPhoneNumber(item.people.mobile) }}
                    </span>
                  <div class="user-info-time">{{ item.created_at }}</div>
                </div>
                <div>


                </div>
              </div>
              <div class="message-text-list-item-content">
                {{ item.message }}
              </div>
            </div>
            <div v-else class="right-show">
              <div class="message-text-list-item-content">
                {{ item.message }}
              </div>
              <div class="message-text-list-item-name">
                <div class="user-info">
                  <div class="user-info-name" v-if="item.company || item.people">
                    {{ item.company || $utils.maskPhoneNumber(item.people.mobile) }}
                  </div>
                  <div class="user-info-time">{{ item.created_at }}</div>
                </div>
                <img :src="item.avatar" alt="用户头像" class="message-avatar"/>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="footer-height"></div>
      <div class="send-box">
        <div class="w-1400">
          <div class="send-messsage-box">
            <input v-model="tockInner" placeholder="请输入聊天内容...." placeholder-class="input-placeholder"
                   @keyup.enter="sendMessage"/>
            <!-- @input="handleInput" -->
            <div class="send-button hit-cursor" @click="sendMessage">
              <img src="../../static/index/send.png" alt=""/>
              发送
            </div>
          </div>
        </div>
      </div>
    </div>
    <help></help>
  </div>
</template>
<script>
import topSearch from "../../components/public/top-search.vue";
import help from "../../components/public/help.vue";
import ws from "../../utils/webSocket.js";
import homeTop from "../../components/public/home-top.vue";
import {chat_list} from "../../api/modules/home";

export default {
  name: "message",
  components: {
    topSearch,
    help,
    homeTop,
  },
  data() {
    return {
      keyWords: '',
      tockInner: "",
      messageList: [],
      socket: null,
      page: 1,
      limit: 15,
      totalPage: 0,
      searchText: "",
      // 聊天加载相关状态
      isLoadingMore: false, // 是否正在加载更多消息
      showLoadingTip: false, // 是否显示加载提示
    };
  },
  watch: {
    // messageList(newVal) {
    //   this.scrollToBottom();
    // },
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  mounted() {
    this.initWebSocket();
    this.getList();
  },
  methods: {
    lisOn(e) {
      if (!e.target.value.trim()) {
        this.page = 1
        this.messageList = []
        this.isLoadingMore = true
        this.getList();
      }
    },
    onSearch() {
      this.page = 1
      this.messageList = []
      this.isLoadingMore = true
      this.getList()
      // this.$message.info("搜索内容：" + this.searchText);
    },
    handleMessageListScroll(e) {
      // 防止重复加载
      if (this.isLoadingMore) return;

      // 当滚动到顶部时加载更多历史消息
      if (this.page < this.totalPage && e.target.scrollTop <= 50) {
        this.isLoadingMore = true;

        // 记录当前滚动位置
        const oldScrollHeight = e.target.scrollHeight;
        const oldScrollTop = e.target.scrollTop;

        this.page++;

        // 显示加载提示
        this.showLoadingTip = true;

        chat_list({page: this.page, limit: this.limit}).then((res) => {
          if (res.data && res.data.data && res.data.data.data) {
            const newMessages = res.data.data.data;

            // 将新消息插入到列表前面
            this.messageList = [...newMessages, ...this.messageList];

            // 更新时间排序
            this.messageList.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

            this.totalPage = res.data.data.last_page;

            // 保持用户当前阅读位置
            this.$nextTick(() => {
              const newScrollHeight = e.target.scrollHeight;
              const heightDifference = newScrollHeight - oldScrollHeight;
              e.target.scrollTop = oldScrollTop + heightDifference;

              // 隐藏加载提示
              this.showLoadingTip = false;
              this.isLoadingMore = false;
            });
          }
        }).catch((error) => {
          this.page--; // 恢复页码
          this.showLoadingTip = false;
          this.isLoadingMore = false;
        });
      }
    },
    getList() {

      chat_list({page: this.page, limit: this.limit, keywords: this.keyWords}).then((res) => {
        let data = [...this.messageList, ...res.data.data.data];
        data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        this.messageList = data;
        this.totalPage = res.data.data.last_page;
        if (this.page == 1) {
          this.scrollToBottom();
        }
      });
    },
    scrollToBottom() {
      if (!this.$refs.messageListRef) {
        return;
      }
      // 只有在用户没有主动滚动查看历史消息时才自动滚动到底部
      const messageList = this.$refs.messageListRef;
      const isAtBottom = messageList.scrollTop + messageList.clientHeight >= messageList.scrollHeight - 50;

      if (isAtBottom) {
        this.$nextTick(() => {
          messageList.scrollTop = messageList.scrollHeight;
        });
      }
    },
    initWebSocket() {
      const self = this;
      const handler = {
        onopen: function () {
          console.log("WebSocket 连接已打开");
        },
        onmessage: function (event) {
          let data = JSON.parse(event.data);
          if (!data) {
            return;
          }
          if (data.type === "send") {
            self.messageList.push({
              creator: "",
              company: data.people.company,
              created_at: data.time,
              message: data.message,
              avatar: data.people.avatar,
              people_id: data.people.people_id,
            });
            self.scrollToBottom();
          }
        },
        onclose: function (e) {
          console.log("WebSocket 连接已关闭", e);
        },
        onerror: function (e) {
          console.log("WebSocket 发生错误", e);
        },
        ping: function () {
        },
      };
      const socket = ws(
          "wss",
          this.$api.wsPath,
          443,
          "",
          {},
          handler,
          30000,
          5000,
          "arraybuffer"
      );
      socket.connect();
      this.socket = socket;
    },
    goHome() {
      this.$router.push("/");
    },
    sendMessage() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }
      if (!this.userInfo.mobile) {
        this.$confirm("请绑定手机号码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/bindPhone");
        });
        return;
      }
      if (this.userInfo.status != 1) {
        this.$message.error('您的账号已被禁用')
        return
      }
      if (!this.tockInner.trim()) {
        this.$confirm("消息不能为空", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
        });
        return;
      }
      if (!this.mixCheckUserAudit()) {
        return
      }
      if (this.socket && this.socket.ws && this.socket.ws.readyState === 1) {
        this.socket.send(
            JSON.stringify({
              type: "send",
              message: this.tockInner,
              people_id: this.userInfo.id,
            })
        );
        this.tockInner = "";
      } else {
        this.$message && this.$message.error
            ? this.$message.error("WebSocket 未连接")
            : alert("WebSocket 未连接");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  border: 1px solid #e1e4eb;
  border-radius: 24px;
}

.search-box-input {
  display: flex;
  width: 500px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
  border-radius: 24px;
  background: #f5f7fa;
  overflow: hidden;
}

.search-box-input input[type="text"] {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px 16px;
  font-size: 16px;
  background: transparent;
  color: #333;
  border-radius: 24px 0 0 24px;
  transition: background 0.3s;
}

.search-box-input input[type="text"]:focus {
  background: #fff;
}

.search-btn {
  border: none;
  background: #0543BD;
  color: #fff;
  font-size: 16px;
  padding: 0 28px;
  cursor: pointer;
  border-radius: 0 24px 24px 0;
  transition: background 0.2s;
  outline: none;
  height: 42px;
}

.search-btn:hover {
  background: #66b1ff;
}

.top-h {
  height: 100px;
}

.search-box-box {
  background: rgba($color: #eef0f5, $alpha: 0.5);
}

.back {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;

  .message-big-img {
    width: 24px;
    height: 24px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.message-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url("../../static/index/message-bj.png");
  background-size: 100% 100%;
}

.message-box {
  height: calc(100vh - 240px);
  border-radius: 0px 0px 0px 0px;
  background-size: 100% 100%;
}

.content {
  overflow-y: auto;
  // padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  width: 1400px;
  height: calc(100vh - 240px);
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.3s ease-in-out;

  // 美化滚动条样式
  &::-webkit-scrollbar {
    width: 6px; // 滚动条宽度
  }

  &::-webkit-scrollbar-track {
    background: transparent; // 轨道背景透明
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3); // 滑块颜色，半透明
    border-radius: 3px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(144, 147, 153, 0.5); // 悬停时稍微明显一点
    }
  }

  // Firefox 滚动条样式
  scrollbar-width: thin;
  scrollbar-color: rgba(144, 147, 153, 0.3) transparent;

  .message-text-list-item-box {
    display: flex;
    flex-direction: column;
  }

  .message-text-list {
    display: flex;
    flex-direction: column;
    padding-top: 30px;

    // 加载提示样式
    .loading-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      color: #666;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 8px;
      margin: 10px 0;

      i {
        margin-right: 8px;
        color: #409eff;
        animation: rotate 1s linear infinite;
      }

      span {
        color: #666;
      }
    }

    @keyframes rotate {
      100% {
        transform: rotate(360deg);
      }
    }

    // 美化滚动条样式
    &::-webkit-scrollbar {
      width: 6px; // 滚动条宽度
    }

    &::-webkit-scrollbar-track {
      background: transparent; // 轨道背景透明
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(144, 147, 153, 0.3); // 滑块颜色，半透明
      border-radius: 3px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(144, 147, 153, 0.5); // 悬停时稍微明显一点
      }
    }

    // Firefox 滚动条样式
    scrollbar-width: thin;
    scrollbar-color: rgba(144, 147, 153, 0.3) transparent;

    .right-show {
      align-self: flex-end;
      display: inline-block;
      margin-bottom: 10px;
      max-width: 1000px;
      padding: 4px 5px 2px 14px;
      background: #ffffff;
      border-radius: 6px 6px 0px 6px;
      display: flex;
      align-items: center;

      .message-text-list-item-name {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 5px;
        align-items: center;

        .message-avatar {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-weight: 400;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 50px;
          margin-left: 14px;
        }

        .user-info {
          // display: flex;
          // flex-direction: column;
          // justify-content: space-between;
          // align-items: flex-end;

          .user-info-name {
            font-weight: bold;
            font-size: 12px;
            color: #00112b;
            white-space: nowrap;
            text-align: right;
          }

          .user-info-time {
            font-weight: 400;
            font-size: 12px;
            color: #afafaf;
            white-space: nowrap;
          }
        }
      }

      .message-text-list-item-content {
        margin-right: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #0066ff;
        line-height: 25px;
        text-align: left;
        word-break: break-all;
        /* 或者用 break-word */
        /* 或者 */
        overflow-wrap: break-word;
      }
    }

    .message-text-list-item {
      align-self: flex-start;
      display: flex;
      margin-bottom: 5px;
      max-width: 1000px;
      padding: 4px 14px 2px 5px;
      background: #ffffff;
      border-radius: 6px 6px 6px 0px;
      align-items: center;

      .message-text-list-item-name {
        display: flex;
        margin-bottom: 5px;
        align-items: center;

        .message-avatar {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-weight: 400;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 50px;
          margin-right: 14px;
        }

        .user-info {
          // display: flex;
          // flex-direction: column;
          // justify-content: space-between;

          .user-info-name {
            font-weight: bold;
            font-size: 12px;
            color: #00112b;
            white-space: nowrap;
          }

          .user-info-time {
            font-weight: 400;
            font-size: 12px;
            color: #afafaf;
            white-space: nowrap;
          }
        }
      }

      .message-text-list-item-content {
        margin-left: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #0066ff;
        line-height: 25px;
        word-break: break-all;
        /* 或者用 break-word */
        /* 或者 */
        overflow-wrap: break-word;
      }
    }
  }
}

// .footer-height {
//   height: 100px;
// }
.send-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: rgba($color: #eef0f5, $alpha: 0.5);
  border-radius: 0px 0px 0px 0px;
  padding: 20px 0;

  .send-messsage-box {
    padding: 19px 37px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e1e4eb;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    input {
      width: 100%;
      height: 100%;
      border: none;
      flex: 1;
      outline: none;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
    }

    .send-button {
      padding: 0 20px;
      box-sizing: border-box;
      width: 100px;
      height: 40px;
      background: #f2f5ff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #bfceff;
      text-align: center;
      line-height: 40px;
      color: #0c60e6;

      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
      }
    }
  }
}
</style>
